import React, { use, useEffect, useRef } from "react";
import Select, { components } from "react-select";
import { Modal } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import InputText from "../../common/Input/InputText";
import InputDate from "../../common/Input/InputDate";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";
import { getTaxSlice } from "../../../store/slices/taxSlice";
import {
  getMedicineSlice,
  createMedicineSlice,
} from "../../../store/slices/medicineMasterSlice";
import AddUpdateMedicineMaster from "../medicineMaster/addUpdateMedicineMaster";
import { getAllSpecialization } from "../../../store/slices/specializationSlice";

const AddUpdateItem = ({
  showItemModal,
  setShowItemModal,
  isMode,
  handleAddItem,
  medicineTypes,
}) => {
  const initialState = {
    name: "",
    hsnCode: "",
    batchNumber: "",
    expiryDate: "",
    unit: "",
    medicineType: "",
    medicineTypeName: "",
    quantity: "",
    freeQuantity: "",
    purchasePrice: "",
    mrp: "",
    rmrp: "",
    discount: "",
    taxRate: "",
    isInclusiveTax: "Yes",
    total: "",
  };
  const [itemFormData, setItemFormData] = useState({ ...initialState });
  const [calculatedValues, setCalculatedValues] = useState({
    cgst: 0,
    sgst: 0,
    total: 0,
  });
  const [showMedicineModal, setShowMedicineModal] = useState(false);
  const [medicineFormData, setMedicineFormData] = useState({});
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getTaxSlice({ token }));
    dispatch(getMedicineSlice({ token }));
    dispatch(getAllSpecialization({ token }));
  }, [dispatch, token]);
  const { tax } = useSelector((state) => state.tax);
  const { medicine } = useSelector((state) => state.medicineMaster);
  const { specializations } = useSelector((state) => state.specializations);

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    let newItemFormData = { ...itemFormData, [name]: value };
    if (["quantity", "purchasePrice", "discount"].includes(name)) {
      const quantity = parseFloat(newItemFormData?.quantity) || 0;
      const purchasePrice = parseFloat(newItemFormData?.purchasePrice) || 0;
      const discount = parseFloat(newItemFormData?.discount) || 0;

      const taxbleAmount = quantity * purchasePrice * (1 - discount / 100);
      newItemFormData.taxbleAmount = taxbleAmount.toFixed(2);

      const tax = parseFloat(newItemFormData?.tax) || 0;
      const taxAmount = taxbleAmount * (tax / 100);
      newItemFormData.taxAmount = taxAmount.toFixed(2);

      const totalAmount = taxbleAmount + taxAmount;
      newItemFormData.totalAmount = totalAmount.toFixed(2);
    }

    setItemFormData(newItemFormData);
  };
  const handleTaxChange = (taxData) => {
    setItemFormData({ ...itemFormData, taxRate: taxData?.value });
  };
  const handleNameChange = (selectedMedicine) => {
    const selected = medicine?.find(
      (m) => m.brandName === selectedMedicine?.value
    );
    if (selected) {
      setItemFormData({
        ...itemFormData,
        name: selected.brandName,
        hsnCode: selected.purchaseHsnCode || "",
        batchNumber: selected.purchaseBatch || "",
        unit: selected.packSize || "",
        medicineType: selected.medicineType || "",
        medicineTypeName: selected.medicineTypeName || "",
        mrp: selected.purchaseMrp || "",
        rmrp: selected.purchaseRmrp || "",
        expiryDate: selected.purchaseExpiryDate || "",
      });
    } else {
      setItemFormData({ ...itemFormData, name: selectedMedicine?.value });
    }
  };
  const handleMedicineTypeChange = (medicineType) => {
    setItemFormData({
      ...itemFormData,
      medicineType: medicineType?.value,
      medicineTypeName: medicineType?.label,
    });
  };
  const handleIsInclusiveChange = (data) => {
    setItemFormData({ ...itemFormData, isInclusiveTax: data?.value });
  };
  const handleItemSubmit = (e) => {
    e.preventDefault();
    handleAddItem({
      ...itemFormData,
      cgst: calculatedValues?.cgst,
      sgst: calculatedValues?.sgst,
      totalAmount: calculatedValues?.totalAmount,
    });
    setItemFormData({ ...initialState });
  };

  useEffect(() => {
    const taxable = parseFloat(itemFormData?.taxbleAmount) || 0;
    const taxRate = parseFloat(itemFormData?.taxRate) || 0;

    if (itemFormData?.isInclusiveTax === "No") {
      const taxAmount = (taxable * taxRate) / 100;
      const cgst = taxAmount / 2;
      const sgst = taxAmount / 2;
      const totalAmount = taxable + taxAmount;

      setCalculatedValues({
        cgst,
        sgst,
        totalAmount,
      });
    } else if (itemFormData?.isInclusiveTax === "Yes") {
      setCalculatedValues({
        cgst: 0,
        sgst: 0,
        totalAmount: taxable,
      });
    }
  }, [
    itemFormData?.taxbleAmount,
    itemFormData?.isInclusiveTax,
    itemFormData?.taxRate,
  ]);

  const customOptions = medicine?.map((item) => ({
    value: item?.brandName,
    label: item?.brandName,
  }));

  // Add an 'Add Supplier' option
  const optionsWithAdd = [
    ...customOptions,
    { value: "add_new", label: "Add New", isAddNew: true },
  ];

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;

    if (data.isAddNew) {
      return (
        <div
          ref={innerRef}
          {...innerProps}
          className="d-flex align-items-center px-2 py-1 text-primary"
          style={{ cursor: "pointer" }}
        >
          <FaPlus className="me-2" />
          <span>Add New</span>
        </div>
      );
    }

    return <components.Option {...props} />;
  };

  const handleSetMedicineFormData = (e) => {
    setMedicineFormData({
      ...medicineFormData,
      [e.target.name]: e?.target?.value,
    });
  };

  const handleSetDepartmentEdit = (items) => {
    setMedicineFormData({
      ...medicineFormData,
      department: items?.map((i) => i.value), // ARRAY
      departmentName: items?.map((i) => i.label), // ARRAY
    });
  };

  const handleSetMedicineTypeEdit = (item) => {
    setMedicineFormData({
      ...medicineFormData,
      medicineType: item?.value,
      medicineTypeName: item?.label,
    });
  };

  const handleAddOrUpdateMedicine = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        createMedicineSlice({ ...medicineFormData, token })
      );
      const newMedicine = response?.payload?.result?.list;
      if (newMedicine?._id) {
        setShowMedicineModal(false);
        setShowItemModal(true);
        setMedicineFormData({});
        setItemFormData({
          ...itemFormData,
          name: newMedicine?.brandName,
          unit: newMedicine.packSize || "",
          medicineType: newMedicine?.medicineType || "",
          medicineTypeName: newMedicine?.medicineType?.name || "",
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <Modal
        centered
        show={showItemModal}
        onHide={() => setShowItemModal(false)}
        size="lg"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {isMode === true ? "EDIT ITEM" : "ADD ITEM"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowItemModal(false);
              setItemFormData({ ...initialState });
            }}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleItemSubmit}>
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <label className="col-form-label">Name</label>
                  <Select
                    name="name"
                    value={
                      itemFormData?.name
                        ? {
                            value: itemFormData?.name,
                            label: itemFormData?.name,
                          }
                        : null
                    }
                    placeholder="Select Name"
                    onChange={(selectedOption) => {
                      if (selectedOption?.value === "add_new") {
                        setShowItemModal(false);
                        setShowMedicineModal(true);
                        setMedicineFormData({status:"Active"  });
                      } else {
                        handleNameChange(selectedOption, "name");
                      }
                    }}
                    options={optionsWithAdd}
                    components={{ Option: CustomOption }}
                    filterOption={(option, input) => {
                      if (option?.data?.isAddNew) return true;
                      return option?.label
                        .toLowerCase()
                        .includes(input?.toLowerCase());
                    }}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputText
                    name="hsnCode"
                    value={itemFormData?.hsnCode}
                    onChange={handleItemChange}
                    label="HSN Code"
                    placeholder={"Enter HSN Code"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputText
                    name="batchNumber"
                    value={itemFormData?.batchNumber}
                    onChange={handleItemChange}
                    label="Batch Number"
                    placeholder={"Enter Batch Number"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputDate
                    name="expiryDate"
                    value={itemFormData?.expiryDate?.split("T")[0]}
                    onChange={(e) => handleItemChange(e, "expiryDate")}
                    placeholder="Expiry Date"
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-2">
                <div className="form-group">
                  <label className="col-form-label">Type</label>
                  <Select
                    name="medicineType"
                    value={
                      itemFormData?.medicineType
                        ? {
                            value: itemFormData?.medicineType,
                            label: itemFormData?.medicineTypeName,
                          }
                        : null
                    }
                    placeholder="Type"
                    onChange={(selectedOption) =>
                      handleMedicineTypeChange(selectedOption, "medicineType")
                    }
                    options={medicineTypes?.map((item) => ({
                      value: item?._id,
                      label: item?.name,
                    }))}
                  />
                </div>
              </div>
              <div className="col-xl-2">
                <div className="form-group position-relative">
                  <InputText
                    name="unit"
                    value={itemFormData?.unit}
                    onChange={handleItemChange}
                    label="Unit"
                    placeholder={"Eg: 10's"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="quantity"
                    value={itemFormData?.quantity}
                    onChange={handleItemChange}
                    label="Quantity"
                    placeholder={"Enter Quantity"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="freeQuantity"
                    value={itemFormData?.freeQuantity}
                    onChange={handleItemChange}
                    label="Free Quantity"
                    placeholder={"Enter Free Quantity"}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="purchasePrice"
                    value={itemFormData?.purchasePrice}
                    onChange={handleItemChange}
                    label="Purchase Price"
                    placeholder={"In Rs Per Unit"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="discount"
                    value={itemFormData?.discount}
                    onChange={handleItemChange}
                    label="Discount(%)"
                    placeholder={"Enter Discount"}
                  />
                </div>
              </div>
              <div className="col-xl-3">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="taxableAmount"
                    value={itemFormData?.taxbleAmount}
                    onChange={handleItemChange}
                    label="Taxable Amount"
                    placeholder={"Taxable Amount"}
                    required={true}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="col-xl-2">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="mrp"
                    value={itemFormData?.mrp}
                    onChange={handleItemChange}
                    label="MRP"
                    placeholder={"MRP"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-2">
                <div className="form-group position-relative">
                  <InputOnlyNumber
                    name="rmrp"
                    value={itemFormData?.rmrp}
                    onChange={handleItemChange}
                    label="RMRP"
                    placeholder={"RMRP"}
                    required={true}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Tax Rate(%)</label>
                  <Select
                    name="taxRate"
                    value={
                      itemFormData?.taxRate
                        ? {
                            value: itemFormData?.taxRate,
                            label: itemFormData?.taxRate,
                          }
                        : null
                    }
                    placeholder="Select Tax Rate(%)"
                    onChange={(selectedOption) =>
                      handleTaxChange(selectedOption, "taxRate")
                    }
                    options={tax?.map((item) => ({
                      value: item?.taxRate,
                      label: item?.taxRate,
                    }))}
                  />
                </div>
              </div>
              <div className="col-xl-3">
                <div className="form-group">
                  <label className="col-form-label">Inclusive Of Tax</label>
                  <Select
                    name="isIclusiveTax"
                    value={
                      itemFormData?.isInclusiveTax
                        ? {
                            value: itemFormData?.isInclusiveTax,
                            label: itemFormData?.isInclusiveTax,
                          }
                        : null
                    }
                    placeholder="Select One"
                    onChange={(selectedOption) =>
                      handleIsInclusiveChange(selectedOption, "inclusiveOfTax")
                    }
                    options={[
                      { value: "Yes", label: "Yes" },
                      { value: "No", label: "No" },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 text-end fw-bold">
              {itemFormData?.isInclusiveTax === "No" && (
                <>
                  <p>
                    <strong>CGST:</strong> ₹{calculatedValues?.cgst?.toFixed(2)}
                  </p>
                  <p>
                    <strong>SGST:</strong> ₹{calculatedValues?.sgst?.toFixed(2)}
                  </p>
                </>
              )}
              <p>
                <strong>Total Amount:</strong> ₹
                {calculatedValues?.totalAmount?.toFixed(2)}
              </p>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowItemModal(false);
                  setItemFormData({ ...initialState });
                }}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                {isMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <AddUpdateMedicineMaster
        setModalVisible={setShowMedicineModal}
        modalVisible={showMedicineModal}
        medicineType={medicineTypes}
        specializations={specializations}
        handleSetMedicineTypeEdit={handleSetMedicineTypeEdit}
        handleSetDepartmentEdit={handleSetDepartmentEdit}
        handleSetMedicineFormData={handleSetMedicineFormData}
        handleAddOrUpdateMedicine={handleAddOrUpdateMedicine}
        medicineFormData={medicineFormData}
      />
    </>
  );
};

export default AddUpdateItem;
